export const initShieldedSite = () => {
  window.onload = function () {
    const frameName = new ds07o6pcmkorn({
      openElementId: '#shielded-logo',
      modalID: 'modal',
    });
    frameName.init();
  };
};

export default 'initShieldedSite';
